import { createPortal } from 'react-dom';

/**
 * Portal — rend ses enfants dans document.body (ou container fourni)
 * de façon SYNCHRONE. Synchrone car les composants flottants
 * (DropdownMenu, Popover, Tooltip, Combobox) doivent voir leur ref
 * peuplée immédiatement pour calculer la position dans useLayoutEffect.
 */
export function Portal({ children, container }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, container || document.body);
}

export default Portal;
